import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "preact/jsx-runtime";
import { createRef, useContext } from 'preact/compat';
import { DummyLink } from '@genericBookings/components/SelectedOption/styles';
import useGetFormDataAsParams from '@genericBookings/hooks/useGetFormDataAsParams';
import Price from './components/Price';
import Styles from './styles';
function Overview(props) {
    const { showAttendees, attendeesString, options, } = props;
    const { loggedIn, showTotalPrice, } = useContext(options);
    const getSuccessUrlData = useGetFormDataAsParams();
    const ref = createRef();
    return (_jsx(_Fragment, { children: _jsxs(Styles.Wrapper, { ref: ref, children: [showTotalPrice && (_jsx(Price, { options: options })), _jsxs(Styles.Selection, { children: [(showAttendees && attendeesString) && _jsx("span", { children: attendeesString }), !loggedIn && (_jsx(DummyLink, { onClick: () => {
                                window.dispatchEvent(new CustomEvent('login.open'));
                                window.dispatchEvent(new CustomEvent('login.successUrl', { detail: getSuccessUrlData() }));
                            }, children: "Member? Login for cheaper prices!" }))] })] }) }));
}
Overview.defaultProps = {
    showAttendees: false,
};
export default Overview;
